import React, { } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import AvaliacaoAlunoPorAvaliacaoTableGroup from './AvaliacaoAlunoPorAvaliacaoTableGroup';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from 'react-router-dom';
import AvaliacaoAlunoEnviar from './AvaliacaoAlunoEnviar';
import { useSelector } from 'react-redux';
import AvaliacaoAlunoForm from './AvaliacaoAlunoForm';

const useStyles = makeStyles({
    paper: {
        padding: '20px',
    },
    title: {
        marginBottom: '20px',
    },
    voltarButton: {
        marginBottom: '20px',
        marginRight: '10px',
        cursor: 'pointer'
    }
});

export default function AvaliacaoAlunoContainer() {
    const classes = useStyles();
    const avaliacao = useSelector(state => state.avaliacao);
    const avaliacaoAluno = useSelector(state => state.avaliacaoAluno);


    return (
        <div>
            <Container className={classes.paper} component={Paper}>
                <Link to={{
                    pathname: '/avaliacao'
                }}>
                    <Button
                        variant="contained"
                        color="secondary"
                        className={classes.voltarButton}
                    >
                        <ArrowBackIcon style={{ marginRight: '10px' }} />
                        Voltar
                    </Button>
                </Link>




                <Typography className={classes.title} variant="h6">
                    Avaliação Aluno
                </Typography>

                {avaliacaoAluno ? <AvaliacaoAlunoForm /> :
                    <>
                        {avaliacao && avaliacao.esimulado ? '' : <AvaliacaoAlunoEnviar />}
                        <AvaliacaoAlunoPorAvaliacaoTableGroup />
                    </>}

            </Container>

        </div>
    );
}